import * as XLSX from 'xlsx-js-style';
import type { RoundsByCompaniesNames } from './interfaces';
import type { ExcelTemplate } from '../../interfaces';
import { withHeaderStyling, setColumnWidth } from '../../utils';
import { getPreparedData, getPreparedDataForAllCompanies } from './mappings';
import { getHeaders } from './headers';
import { RoundTableExcel } from 'src/app/domain/company-performance/round/round-table/round-table.component';

export class AllCompaniesRoundsByPeriodTemplate implements ExcelTemplate {
  MAX_KEY_LENGTH = 30;
  export(data: RoundsByCompaniesNames): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const keys = Object.keys(data);
    const firstSheet = this.getFirstSheet(data);
    XLSX.utils.book_append_sheet(book, firstSheet, 'All companies');
    for (let key of keys) {
      if (key.length > this.MAX_KEY_LENGTH) {
        const newKey = key.slice(0, this.MAX_KEY_LENGTH - 3) + '...';
        data[newKey] = data[key];
        key = newKey;
      }
      const sheet = this.getSheet(data[key]);
      XLSX.utils.book_append_sheet(book, sheet, key);
    }
    return book;
  }

  /**
   * Here I'm using array of arrays, because I need prepare cells properly with
   * format, styles, etc.
   */
  private getSheet(data: RoundTableExcel): XLSX.WorkSheet {
    const headers = getHeaders();
    const preparedData = getPreparedData(data, headers);
    const sheet = XLSX.utils.aoa_to_sheet(preparedData);
    const bigColumns = [0];
    const midColumns = [];
    for (let i = 1; i < headers.length; i++) {
      midColumns.push(i);
    }
    bigColumns.forEach((index) => setColumnWidth(sheet, index, 25));
    midColumns.forEach((index) => setColumnWidth(sheet, index, 13));
    return withHeaderStyling(sheet);
  }

  private getFirstSheet(data: RoundsByCompaniesNames): XLSX.WorkSheet {
    const headers = getHeaders();
    const preparedData = getPreparedDataForAllCompanies(data, headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
    };
    const bigColumns = [0, 1];
    const midColumns = [];
    for (let i = 2; i < headers.length; i++) {
      midColumns.push(i);
    }
    bigColumns.forEach((index) => setColumnWidth(sheet, index, 25));
    midColumns.forEach((index) => setColumnWidth(sheet, index, 13));
    return withHeaderStyling(sheet);
  }

}

